import { render, staticRenderFns } from "./KPIProgress.vue?vue&type=template&id=df3b3654&scoped=true"
import script from "./KPIProgress.vue?vue&type=script&lang=js"
export * from "./KPIProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3b3654",
  null
  
)

export default component.exports